import './Template/_Fragment/Header/Navigation/HeaderNavigation.js'
import './Template/_Fragment/Header/Header.js'
import './Template/_Fragment/Footer/Navigation/FooterNavigation.js'
import './Component/_Fragment/SliderCollection/SliderCollection.js';
import './Component/TextMedia/TextMedia.js'


import { slider } from './Component/_Fragment/SliderCollection/SliderCollection.js';

document.addEventListener('Neos.NodeCreated', function(event) {
    const element = event.detail.element;

    if(element.querySelector('.slider')) {
        slider()
    }
})